<template>
	<div class="animated fadeIn">
		<CommandHeaderV2 :command_service_id="service_id" :record_id="command_id" active="response">
			<div class="pt-3 pr-3 pb-0 pl-3">
				<!-- START RESPONSE TYPE -->
				<b-card>
					<div slot="header">{{ $t('Response Type') }}</div>
					<tooltip label="Response Type" placement="right" class="m-0">
						<select v-model="record.resp_type" class="form-control" @change="handle_on_change_res_type">
							<template v-for="(type, i) in $store.state.command.response.types">
								<option
									v-if="type && !type.hide"
									:disabled="type.value.toUpperCase() === 'COMPONENT' && components.length === 0"
									:value="type.value"
									:key="'resp_type_' + i"
									:selected="type.value === record.resp_type"
								>{{ $t(type.label) }}</option>
							</template>
						</select>
					</tooltip>

					<!-- START RESPONSE TYPE TEXT -->
					<div
						v-if="
                                record.resp_type == 'text'
                                || record.resp_type == 'sub'
                                || record.resp_type == 'static_cards'
								|| record.resp_type == 'quick_rep'
                                "
						class="mt-3"
					>
						<tooltip label="text" placement="right">
							<input
								class="form-control"
								v-autocomplete="autocomplete"
								v-model="record.resp_text"
								:placeholder="$t('text')"
							/>
						</tooltip>
					</div>
					<!-- END RESPONSE TYPE TEXT -->

					<!-- START RESPONSE TYPE MENU -->
					<tooltip
						v-if="['menu', 'shopping_cart'].indexOf(record.resp_type) >= 0"
						label="Menu"
						placement="right"
						class="mt-3"
					>
						<select
							v-model="record.resp_menu_id"
							name="menu_dataset"
							v-validate="'required|min_value:1'"
							:class="{'form-control': true, 'is-invalid': errors.has('menu_dataset')}"
						>
							<option :value="0" disabled>{{$t('choose menu')}}</option>
							<option v-for="(item, i) in menu_dataset" :value="item.ds_id">{{ item.ds_name }}</option>
						</select>
						<span
							v-if="errors.has('menu_dataset')"
							class="help is-danger invalid-feedback"
						>{{ $t(errors.first('menu_dataset')) }}</span>
					</tooltip>
					<!-- END RESPONSE TYPE MENU -->

					<!-- START RESPONSE TYPE SHOPPING CART -->
					<div v-if="record.resp_type == 'shopping_cart'">
						<tooltip label="Cart action" placement="right">
							<select
								v-model="record.resp_cart_action"
								name="resp_cart_action"
								:class="{'form-control': true}"
							>
								<option
									v-for="(item, i) in $store.state.command.response.shoppingCartActions"
									:value="item.value"
									:key="'command.response.shoppingCartActions_' + i"
								>{{ $t(item.label) }}</option>
							</select>
						</tooltip>
						<div
							v-if="record.resp_cart_action != 'view_receipt'
                                    && record.resp_cart_action != 'complete_order'"
						>
							<tooltip label="Item title" placement="right">
								<select
									v-model="record.resp_cart_title"
									name="resp_cart_title"
									v-validate="'required|min_value:1'"
									:class="{'form-control': true, 'is-invalid': errors.has('resp_cart_title')}"
								>
									<option :value="0" disabled>{{$t('choose item title')}}</option>
									<option
										v-for="id in Object.keys(vars_ids)"
										:value="id"
										:key="'item_title_'+id"
									>{{ vars_ids[id] }}</option>
								</select>
								<span
									v-if="errors.has('resp_cart_title')"
									class="help is-danger invalid-feedback"
								>{{ $t(errors.first('resp_cart_title')) }}</span>
							</tooltip>
							<tooltip label="Item quantity" placement="right">
								<select
									v-model="record.resp_cart_quantity"
									name="resp_cart_quantity"
									v-validate="'required|min_value:1'"
									:class="{'form-control': true, 'is-invalid': errors.has('resp_cart_quantity')}"
								>
									<option :value="0" disabled>{{$t('choose item quantity')}}</option>
									<option
										v-for="id in Object.keys(vars_ids)"
										:value="id"
										:key="'item_quantity_'+id"
									>{{ vars_ids[id] }}</option>
								</select>
								<span
									v-if="errors.has('resp_cart_quantity')"
									class="help is-danger invalid-feedback"
								>{{ $t(errors.first('resp_cart_quantity')) }}</span>
							</tooltip>
						</div>
					</div>
					<!-- END RESPONSE TYPE SHOPPING CART -->

					<div v-if="record.resp_type == 'menu'">
						<table class="table table-bordered table-striped table-sm">
							<thead>
								<tr>
									<th>{{ $t('Label') }}</th>
									<th>{{ $t('Value') }}</th>
									<th>{{ $t('action') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(opt, index) in record.resp_menu_extra_options" :key="'menu_card_' + index ">
									<td v-html="autoCompleteTextToHTML(opt.label, $store.state.menuAutocomplete)"></td>
									<td v-html="autoCompleteTextToHTML(opt.value, $store.state.menuAutocomplete)"></td>
									<td class="col d-inline-flex justify-content-center align-items-center">
										<span
											:title="$t('edit')"
											@click="react_menu_extra = Object.assign(opt, {position: index, mode: 'edit'})"
										>
											<i class="fa fa-edit"></i>
										</span>
										&nbsp;
										<span
											:title="$t('delete')"
											@click="record.resp_menu_extra_options.splice(index, 1)"
										>
											<i class="fa fa-remove"></i>
										</span>
									</td>
								</tr>
								<tr v-if="!record.resp_menu_extra_options.length">
									<td colspan="2">
										<div class="text-center">{{ $t('no data') }}</div>
									</td>
								</tr>
							</tbody>
						</table>

						<tooltip label="label" placement="right">
							<input
								name="resp_menu_extra_opt_label"
								:placeholder="$t('label')"
								v-model="react_menu_extra.label"
								v-validate.disable="'required'"
								:class="{'form-control': true, 'is-invalid': errors.has('resp_menu_extra_opt_label')}"
								v-autocomplete="$store.state.menuAutocomplete"
							/>
							<span
								v-if="errors.has('resp_menu_extra_opt_label')"
								class="help is-danger invalid-feedback"
							>{{ $t(errors.first('resp_menu_extra_opt_label')) }}</span>
						</tooltip>

						<tooltip label="value" placement="right">
							<input
								name="resp_menu_extra_opt_value"
								:placeholder="$t('value')"
								v-model="react_menu_extra.value"
								v-validate.disable="'required'"
								:class="{'form-control': true, 'is-invalid': errors.has('resp_menu_extra_opt_value')}"
								v-autocomplete="$store.state.menuAutocomplete"
							/>
							<span
								v-if="errors.has('resp_menu_extra_opt_value')"
								class="help is-danger invalid-feedback"
							>{{ $t(errors.first('resp_menu_extra_opt_value')) }}</span>
						</tooltip>

						<button class="btn btn-primary" type="button" @click="handle_click_menu_extra">
							<i :class="'fa fa-' + (react_menu_extra.mode == 'add' ? 'plus' : 'edit')"></i>
							&nbsp;{{ $t(react_menu_extra.mode) }}
						</button>
					</div>

					<!-- Static Quick Replies -->
					<div v-if="record.resp_type == 'quick_rep'">
						<CommandResponseQuickReply
							:autoCompleteModules="autocomplete"
							:records="record.resp_quick_reply"
							:private_services="private_services"
							:public_services="public_services"
							:command_id_to_name="command_id_to_name"
							v-on:passQuickReplies="onQuickReplySave"
						>
						</CommandResponseQuickReply>
					</div>

					<!-- START RESPONSE TYPE STATIC CARDS -->
					<div v-if="record.resp_type == 'static_cards'">
						<table
							class="table table-bordered table-striped table-sm"
							v-if="record.resp_static_cards_resp_struct && record.resp_static_cards_resp_struct.length"
						>
							<thead>
								<tr>
									<th>{{ $t('Title') }}</th>
									<th>{{ $t('Sub title') }}</th>
									<th>{{ $t('actions') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(card, ic) in record.resp_static_cards_resp_struct"
									:key="`response-static-card-${ic}`"
								>
									<td v-html="card.title_key || card.title_default_value "></td>
									<td v-html="card.subtitle_key || card.subtitle_default_value "></td>
									<td class="text-center">
										<button type="button" class="btn btn-link p-0 mr-2">
											<i @click="static_card_emit('edit', ic)" class="fa fa-edit fa-lg" :title="$t('edit')"></i>
										</button>
										<button type="button" class="btn btn-link p-0 mr-2">
											<i
												@click="static_card_emit('delete', ic)"
												class="fa fa-remove fa-lg"
												:title="$t('delete')"
											></i>
										</button>
									</td>
								</tr>
								<tr v-if="!record.resp_static_cards_resp_struct.length">
									<td colspan="4">
										<div class="text-center">{{ $t('no data') }}</div>
									</td>
								</tr>
							</tbody>
						</table>

						<b-alert variant="danger" dismissible :show="!!error_resp_static_cards_resp_struct">
							<button
								type="button"
								aria-label="Close"
								class="close"
								@click="error_resp_static_cards_resp_struct = false"
							>x</button>
							<div v-html="error_resp_static_cards_resp_struct"></div>
						</b-alert>

						<ComamandResponseCard
							:buttons="resp_static_cards_resp_struct.buttons"
							:btnLabel="resp_static_cards_resp_struct.item_label_key || resp_static_cards_resp_struct.item_label_default_value"
							:title="resp_static_cards_resp_struct.title_key || resp_static_cards_resp_struct.title_default_value"
							:subTitle="resp_static_cards_resp_struct.subtitle_key || resp_static_cards_resp_struct.subtitle_default_value"
							:autoCompleteModules="autocomplete"
							:checkMediaBackground="true"
							:media="resp_static_cards_resp_struct.media_key || resp_static_cards_resp_struct.media_default_value"
							@onNewButtonClick="push_button(resp_static_cards_resp_struct.buttons)"
							@onRemoveButtonClick="(pos) => remove_button(pos, resp_static_cards_resp_struct.buttons)"
						>
							<template slot="title">
								<tooltip label="value" placement="right">
									<input
										name="title_key"
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="resp_static_cards_resp_struct.title_key"
										:placeholder="$t('value')"
									/>
								</tooltip>
								<tooltip label="default value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="resp_static_cards_resp_struct.title_default_value"
										:placeholder="$t('default value')"
									/>
								</tooltip>
							</template>

							<template slot="subTitle">
								<tooltip label="value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="resp_static_cards_resp_struct.subtitle_key"
										:placeholder="$t('value')"
									/>
								</tooltip>
								<tooltip label="default value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="resp_static_cards_resp_struct.subtitle_default_value"
										:placeholder="$t('default value')"
									/>
								</tooltip>
							</template>

							<template slot="media">
								<tooltip label="value" placement="right">
									<image-uploader
										:imageType="'file'"
										:imagePreview="false"
										@imageSelected="image => resp_static_cards_resp_struct.media_key = image.dataURI"
										@linkChanged="link => resp_static_cards_resp_struct.media_key = link"
									></image-uploader>
								</tooltip>
								<!-- <tooltip label="default value" placement="right">
											<input
												class="form-control"
												v-autocomplete="autocomplete"
												v-model="resp_static_cards_resp_struct.media_default_value"
												:placeholder="$t('default value')"
											/>
								</tooltip>-->
							</template>

							<template
								:slot="'button.' + ii"
								v-for="(button, ii) in  resp_static_cards_resp_struct.buttons"
							>
								<tooltip label="button label" placement="right" :key="'button.label.' + ii">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="button.item_label_key"
										:placeholder="$t('button label')"
									/>
								</tooltip>

								<tooltip label="button value" placement="right" :key="'button.value.' + ii">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="button.item_value_key"
										:placeholder="$t('button value')"
									/>
								</tooltip>
							</template>
						</ComamandResponseCard>

						<div class="form-group form-actions mt-0 mb-0">
							<button
								:disabled="record.resp_static_cards_resp_struct.length >= 5"
								type="button"
								v-show="mode_resp_static_cards_resp_struct == 'add'"
								@click="static_card_emit('add')"
								class="btn btn-primary btn-sm btn-square mb-0"
							>{{ $t('Add Card') }}</button>
							<button
								type="button"
								v-show="mode_resp_static_cards_resp_struct == 'edit'"
								@click="static_card_emit('update')"
								class="btn btn-success btn-sm btn-square active mb-0"
							>{{ $t('Edit Card') }}</button>
						</div>
					</div>
					<!-- END RESPONSE TYPE STATIC CARDS -->

					<!-- START RESPONSE TYPE LOCATION -->
					<div v-if="record.resp_type == 'location'">
						<table class="table table-bordered table-striped table-sm">
							<thead>
								<tr>
									<th>{{ $t('title') }}</th>
									<th>{{ $t('longitude') }}</th>
									<th>{{ $t('latitude') }}</th>
									<th>{{ $t('action') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(loc, ic) in record.resp_location_resp_struct">
									<td>{{ loc.title }}</td>
									<td>{{ loc.lng }}</td>
									<td>{{ loc.lat }}</td>
									<td class="text-center">
										<button type="button" class="btn btn-link p-0 mr-2">
											<i @click="location_emit('edit', ic)" class="fa fa-edit fa-lg" :title="$t('edit')"></i>
										</button>
										<button type="button" class="btn btn-link p-0 mr-2">
											<i @click="location_emit('delete', ic)" class="fa fa-remove fa-lg" :title="$t('delete')"></i>
										</button>
									</td>
								</tr>
								<tr v-if="!record.resp_location_resp_struct.length">
									<td colspan="4">
										<div class="text-center">{{ $t('no data') }}</div>
									</td>
								</tr>
							</tbody>
						</table>
						<b-alert variant="danger" dismissible :show="!!resp_location_resp_struct.error">
							<button
								type="button"
								aria-label="Close"
								class="close"
								@click="resp_location_resp_struct.error = false"
							>Ã—</button>
							<div v-html="resp_location_resp_struct.error"></div>
						</b-alert>
						<GeoLocation
							:title="resp_location_resp_struct.title"
							:lng="resp_location_resp_struct.lng"
							:lat="resp_location_resp_struct.lat"
							@onChangeMarker="handleOnChangeMarker"
						>
							<template slot="fields">
								<tooltip label="title" placement="right">
									<input
										name="title"
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="resp_location_resp_struct.title"
										:placeholder="$t('title')"
									/>
								</tooltip>
								<tooltip label="longitude" placement="right">
									<input
										name="location.lng"
										v-model.lazy="resp_location_resp_struct.lng"
										:placeholder="$t('longitude')"
										v-validate="'decimal:18'"
										:class="{'form-control': true, 'is-invalid': errors.has('location.lng')}"
										type="text"
									/>
									<span
										v-if="errors.has('location.lng')"
										class="help is-danger invalid-feedback"
									>{{ $t(errors.first('location.lng')) }}</span>
								</tooltip>
								<tooltip label="latitude" placement="right">
									<input
										name="location.lat"
										v-model.lazy="resp_location_resp_struct.lat"
										:placeholder="$t('latitude')"
										v-validate="'decimal:18'"
										:class="{'form-control': true, 'is-invalid': errors.has('location.lat')}"
										type="text"
									/>
									<span
										v-if="errors.has('location.lat')"
										class="help is-danger invalid-feedback"
									>{{ $t(errors.first('location.lat')) }}</span>
								</tooltip>
							</template>
						</GeoLocation>
						<div class="form-group form-actions mt-0 mb-0">
							<button
								:disabled="record.resp_location_resp_struct.length >= 5"
								type="button"
								v-show="resp_location_resp_struct.mode == 'add'"
								@click="location_emit('add')"
								class="btn btn-primary btn-sm btn-square mb-0"
							>{{ $t('Add Location') }}</button>
							<button
								type="button"
								v-show="resp_location_resp_struct.mode == 'edit'"
								@click="location_emit('update')"
								class="btn btn-success btn-sm btn-square active mb-0"
							>{{ $t('Edit Location') }}</button>
						</div>
					</div>
					<!-- END RESPONSE TYPE LOCATION -->

					<!-- START RESPONSE TYPE API -->
					<div v-show="record.resp_type == 'api'">
						<p class="h5">{{ $t('Request Info') }}</p>
						<tooltip label="api url" placement="right">
							<input
								name="api_url"
								v-model="record.resp_api_url"
								v-validate="record.resp_type == 'api' ? 'required' : ''"
								:class="{'form-control': true, 'is-invalid': errors.has('api_url')}"
								type="text"
								:placeholder="$t('Type Response Api URL')"
								v-autocomplete="autocomplete"
								autocomplete="off"
							/>
							<span
								v-if="errors.has('api_url')"
								class="help is-danger invalid-feedback"
							>{{ $t(errors.first('api_url')) }}</span>
						</tooltip>
						<tooltip label="Request Type" placement="right">
							<select v-model="record.resp_api_req_type" class="form-control">
								<option value="get">{{ $t('GET') }}</option>
								<option value="post">{{ $t('POST') }}</option>
								<option value="pars">{{ $t('URL Parameters') }}</option>
							</select>
						</tooltip>
						<tooltip label="Custom Headers" placement="right">
							<textarea
								name="api headers"
								class="form-control"
								v-model="record.resp_api_headers"
								cols="3"
								:placeholder="$t('Type Custom Headers')"
							></textarea>
						</tooltip>
						<p class="h5">{{ $t('Request Parameters') }}</p>
						<table
							v-show="record.resp_api_pars.length > 0"
							class="table table-bordered table-striped table-sm"
						>
							<thead>
								<tr>
									<th>{{ $t('Parameter Name') }}</th>
									<th>{{ $t('Parameter Value') }}</th>
									<th>{{ $t('Parameter Default Value') }}</th>
									<th>{{ $t('actions') }}</th>
									<!-- <th>{{ $t('Delete') }}</th> -->
								</tr>
							</thead>
							<tbody>
								<tr v-for="(par, index) in record.resp_api_pars">
									<td>{{ par.name }}</td>
									<td>{{ par.var_name }}</td>
									<td>{{ par.var_default_value }}</td>
									<td class="text-center">
										<button type="button" class="btn btn-link p-0 mr-2">
											<i
												@click="edit_par_mode('resp_api_pars', index)"
												class="fa fa-edit fa-lg"
												:title="$t('edit')"
											></i>
										</button>
										<button type="button" class="btn btn-link p-0 mr-2">
											<i
												@click="remove_par('resp_api_pars', index)"
												class="fa fa-remove fa-lg"
												:title="$t('delete')"
											></i>
										</button>
									</td>
								</tr>
							</tbody>
						</table>
						<tooltip label="Parameter Name" placement="right">
							<input
								type="text"
								v-model="api_par_resp_api_pars.name"
								class="form-control"
								v-autocomplete="autocomplete"
							/>
						</tooltip>
						<tooltip label="Parameter value" placement="right">
							<select class="form-control" v-model="api_par_resp_api_pars.var_id">
								<option value="0" disabled>{{ $t('None') }}</option>
								<option v-for="(v, i) in vars" :value="v.var_id" :key="i">{{ v.var_name }}</option>
								<option
									class="hl-opt"
									v-for="(sk, x) in Object.keys($store.state.sender_info)"
									:value="sk"
									:key="'sender_info_' + x"
								>{{ $t($store.state.sender_info[sk]) }}</option>
							</select>
						</tooltip>
						<tooltip label="Parameter Default Value" placement="right">
							<input
								type="text"
								v-model="api_par_resp_api_pars.var_default_value"
								class="form-control"
								v-autocomplete="autocomplete"
							/>
						</tooltip>
						<div class="form-group form-actions">
							<button
								type="button"
								v-show="par_mode_resp_api_pars == 'add'"
								@click="add_par('resp_api_pars')"
								class="btn btn-primary btn-sm btn-square"
							>{{ $t('Add Parameter') }}</button>
							<button
								type="button"
								v-show="par_mode_resp_api_pars == 'edit'"
								@click="edit_par('resp_api_pars')"
								class="btn btn-success btn-sm btn-square active"
							>{{ $t('Edit Parameter') }}</button>
						</div>
						<p class="h4">{{ $t('Response Info') }}</p>
						<tooltip label="Response Type" placement="right">
							<select class="form-control" v-model="record.resp_api_resp_type">
								<option value="json">{{ $t('JSON') }}</option>
								<option value="text">{{ $t('Raw Text') }}</option>
							</select>
						</tooltip>
						<tooltip label="Data Field Name" placement="right">
							<input
								name="text"
								v-model="record.resp_api_resp_data_field"
								class="form-control"
								v-autocomplete="autocomplete"
								type="text"
								:placeholder="$t('Text')"
							/>
						</tooltip>
						<tooltip label="Data Type" placement="right">
							<select class="form-control" v-model="record.resp_api_resp_data_type">
								<option value="multi">{{ $t('Multiple') }}</option>
								<option value="single">{{ $t('Signle') }}</option>
							</select>
						</tooltip>
						<tooltip
							label="Data Limit"
							placement="right"
							v-show="record.resp_api_resp_data_type == 'multi'"
						>
							<input
								name="resp_api_resp_data_limit"
								v-model.lazy="record.resp_api_resp_data_limit"
								class="form-control"
								type="text"
							/>
						</tooltip>
						<tooltip label="Response Via" placement="right">
							<select class="form-control" v-model="record.resp_api_resp_via">
								<option value="text">{{ $t('Text') }}</option>
								<option value="card">{{ $t('Card URL or List') }}</option>
								<option value="quick_rep">{{ $t('Quick Replies') }}</option>
								<option value="video">{{ $t('Video') }}</option>
								<option value="Image">{{ $t('Image') }}</option>
							</select>
						</tooltip>
						<ComamandResponseCard
							v-show="record.resp_api_resp_via === 'card'"
							:buttons="record.resp_api_resp_struct.buttons"
							:btnLabel="record.resp_api_resp_struct.item_label_key || record.resp_api_resp_struct.item_label_default_value"
							:title="record.resp_api_resp_struct.title_key || record.resp_api_resp_struct.title_default_value"
							:subTitle="record.resp_api_resp_struct.subtitle_key || record.resp_api_resp_struct.subtitle_default_value"
							:autoCompleteModules="autocomplete"
							@onNewButtonClick="push_button(record.resp_api_resp_struct.buttons)"
							@onRemoveButtonClick="(pos) => remove_button(pos, record.resp_api_resp_struct.buttons)"
						>
							<template slot="title">
								<tooltip label="value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_api_resp_struct.title_key"
										:placeholder="$t('value')"
									/>
								</tooltip>
								<tooltip label="default value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_api_resp_struct.title_default_value"
										:placeholder="$t('default value')"
									/>
								</tooltip>
							</template>
							<template slot="subTitle">
								<tooltip label="value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_api_resp_struct.subtitle_key"
										:placeholder="$t('value')"
									/>
								</tooltip>
								<tooltip label="default value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_api_resp_struct.subtitle_default_value"
										:placeholder="$t('default value')"
									/>
								</tooltip>
							</template>
							<template slot="media">
								<tooltip label="value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_api_resp_struct.media_key"
										:placeholder="$t('value')"
									/>
								</tooltip>
								<tooltip label="default value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_api_resp_struct.media_default_value"
										:placeholder="$t('default value')"
									/>
								</tooltip>
							</template>

							<template
								:slot="'button.' + ii"
								v-for="(button, ii) in  record.resp_api_resp_struct.buttons"
							>
								<tooltip label="button label" placement="right" :key="'button.label.' + ii">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="button.item_label_key"
										:placeholder="$t('button label')"
									/>
								</tooltip>

								<tooltip label="button value" placement="right" :key="'button.value.' + ii">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="button.item_value_key"
										:placeholder="$t('button value')"
									/>
								</tooltip>
							</template>
						</ComamandResponseCard>
						<tooltip label="text" placement="right" v-show="record.resp_api_resp_via === 'text'">
							<input
								class="form-control"
								v-autocomplete="autocomplete"
								v-model="record.resp_api_resp_struct.title_key"
							/>
						</tooltip>
						<div v-if="record.resp_api_resp_via == 'quick_rep'">
							<CommandResponseQuickReply
								:autoCompleteModules="autocomplete"
								:records="record.resp_quick_reply"
								:private_services="private_services"
								:public_services="public_services"
								:command_id_to_name="command_id_to_name"
								v-on:passQuickReplies="onQuickReplySave"
							>
							</CommandResponseQuickReply>
						</div>
					</div>
					<!-- END RESPONSE TYPE API -->

					<!-- START RESPONSE TYPE DATASET -->
					<div v-show="record.resp_type == 'ds'">
						<tooltip label="Dataset name" placement="right">
							<select
								v-on:change="get_dataset_fields"
								v-model="dataset.ds_id"
								class="form-control"
								:disabled="!datasets_list.length"
							>
								<option value="0" disabled="disabled">{{ $t('Choose Dataset') }}</option>
								<option
									v-for="(ds, ds_i) in datasets_list"
									:value="ds.ds_id"
									:key="`ds.ds_id-${ds_i}`"
								>{{ ds.ds_name }}</option>
							</select>
						</tooltip>
						<tooltip label="Query Type" placement="right" v-show="dataset.ds_id > 0 && false">
							<select v-model="dataset.query_type" class="form-control">
								<option value="builder">{{ $t('Builder') }}</option>
								<!-- <option value="query">{{ $t('Query') }}</option> -->
							</select>
						</tooltip>

						<b-card v-show="dataset.query_type == 'builder' && dataset.ds_id > 0">
							<!-- <div class="h5">{{ $t('Query Groups', ':') }}</div> -->
							<div v-for="(group, group_index) in dataset.groups" :key="`query-group-${group_index}`">
								<b-card>
									<div class="row">
										<div class="col-12">
											<p class="h5">{{$t('queries for group')}}</p>
											<table class="table table-bordered table-striped table-sm">
												<tr>
													<th>{{ $t('Field') }}</th>
													<th>{{ $t('Relation') }}</th>
													<th>{{ $t('Variable') }}</th>
													<th>{{ $t('Default Value') }}</th>
													<th>{{ $t('actions') }}</th>
												</tr>

												<template v-if="group.length">
													<tr
														v-for="(elem, elem_index) in group"
														:key="`query-group-${group_index}-${elem_index}`"
													>
														<td>{{ elem.field_name }}</td>
														<td>{{ elem.rel }}</td>
														<td>{{ vars_ids_with_sender_vars[elem.var_id] }}</td>
														<td>{{ elem.value }}</td>
														<td>
															<button type="button" class="btn btn-link p-0 m-0 mr-2">
																<i
																	@click="removeQueryGroupElement(group_index, elem_index)"
																	class="fa fa-remove fa-lg"
																	:title="$t('delete')"
																></i>
															</button>
														</td>
													</tr>
												</template>
												<template v-else>
													<tr>
														<td colspan="4">
															<div class="text-center">{{ $t('no data') }}</div>
														</td>
													</tr>
												</template>
											</table>
										</div>

										<div class="col-md-12">
											<button
												type="button"
												class="btn btn-sm btn-primary ml-0"
												@click="handleOnClickAddQuery(group_index)"
											>{{ $t('Add Query') }}</button>

											<button
												type="button"
												class="btn btn-sm btn-danger"
												@click="removeQueryGroup(group_index)"
											>{{ $t('Remove Group') }}</button>
										</div>
									</div>
								</b-card>
							</div>

							<button
								type="button"
								class="btn btn-primary ml-0"
								@click="addNewQueryGroup()"
							>{{ $t('add new query group') }}</button>
						</b-card>
						<p
							v-show="dataset.query_type == 'builder' && dataset.ds_id > 0"
							class="h4"
						>{{$t('response info')}}</p>
						<div v-show="dataset.query_type == 'builder' && dataset.ds_id > 0">
							<tooltip label="Response Via" placement="right">
								<select class="form-control" v-model="dataset.resp.via">
									<option value="text">{{ $t('Text') }}</option>
									<option value="quick_rep">{{ $t('Quick Replies') }}</option>
									<option value="card">{{ $t('Card (URL or List)') }}</option>
									<option value="video">{{ $t('Video') }}</option>
									<option value="Image">{{ $t('Image') }}</option>
									<option value="receipt">{{ $t('Receipt') }}</option>

								</select>
							</tooltip>
							<tooltip label="Data Limit" placement="right">
								<input
									name="data_limit"
									v-model.lazy="dataset.resp.limit"
									v-validate="'integer'"
									:class="{'form-control': true, 'is-invalid': errors.has('data_limit')}"
									type="text"
								/>
								<span
									v-if="errors.has('data_limit')"
									class="help is-danger invalid-feedback"
								>{{ $t(errors.first('data_limit')) }}</span>
							</tooltip>
							<tooltip label="text" placement="right" v-show="dataset.resp.via === 'text'">
								<input
									class="form-control"
									v-model="dataset.resp.title"
									:placeholder="$t('Title')"
									rows="1"
									v-autocomplete="autocomplete"
								/>
							</tooltip>
							<div v-if="dataset.resp.via == 'quick_rep'">
								<CommandResponseQuickReply
									:autoCompleteModules="autocomplete"
									:records="record.resp_quick_reply"
									:private_services="private_services"
									:public_services="public_services"
									:command_id_to_name="command_id_to_name"
									v-on:passQuickReplies="onQuickReplySave"
								>
								</CommandResponseQuickReply>
							</div>
							
							<!-- </CommandResponseQuickReply> -->
							<ComamandResponseCard
								v-show="dataset.resp.via === 'card'"
								:buttons="dataset.resp.buttons"
								:title="dataset.resp.title"
								:subTitle="dataset.resp.subtitle"
								:autoCompleteModules="autocomplete"
								@onNewButtonClick="push_button(dataset.resp.buttons)"
								@onRemoveButtonClick="(pos) => remove_button(pos, dataset.resp.buttons)"
							>
								<template slot="title">
									<tooltip label="value" placement="right">
										<input
											class="form-control"
											v-autocomplete="autocomplete"
											v-model="dataset.resp.title"
											:placeholder="$t('value')"
										/>
									</tooltip>
								</template>
								<template slot="subTitle">
									<tooltip label="value" placement="right">
										<input
											class="form-control"
											v-autocomplete="autocomplete"
											v-model="dataset.resp.subtitle"
											:placeholder="$t('value')"
										/>
									</tooltip>
								</template>
								<template slot="media">
									<tooltip label="value" placement="right">
										<input
											class="form-control"
											v-autocomplete="autocomplete"
											v-model="dataset.resp.media"
											:placeholder="$t('value')"
										/>
									</tooltip>
								</template>

								<template :slot="'button.' + ii" v-for="(button, ii) in  dataset.resp.buttons">
									<tooltip label="button label" placement="right" :key="'button.label.' + ii">
										<input
											class="form-control"
											v-autocomplete="autocomplete"
											v-model="button.item_label_key"
											:placeholder="$t('button label')"
										/>
									</tooltip>

									<tooltip label="button value" placement="right" :key="'button.value.' + ii">
										<input
											class="form-control"
											v-autocomplete="autocomplete"
											v-model="button.item_value_key"
											:placeholder="$t('button value')"
										/>
									</tooltip>
								</template>
							</ComamandResponseCard>
							<table
								v-show="dataset.resp.via == 'receipt'"
								class="table table-bordered table-striped table-sm"
							>
								<tr>
									<th>{{ $t('Name') }}</th>
									<td>
										<input
											type="text"
											class="form-control"
											v-model="dataset.resp.receipt.name"
											:placeholder="$t('name')"
											autocomplete="off"
											v-autocomplete="autocomplete"
										/>
									</td>
								</tr>
								<tr>
									<th>{{ $t('merchant') }}</th>
									<td>
										<input
											type="text"
											class="form-control"
											v-model="dataset.resp.receipt.merchant"
											:placeholder="$t('merchant')"
											autocomplete="off"
											v-autocomplete="autocomplete"
										/>
									</td>
								</tr>
								<tr>
									<th>{{ $t('order url') }}</th>
									<td>
										<input
											type="text"
											class="form-control"
											v-model="dataset.resp.receipt.order_url"
											:placeholder="$t('order url')"
											autocomplete="off"
											v-autocomplete="autocomplete"
										/>
									</td>
								</tr>
								<tr>
									<th>{{ $t('currency') }}</th>
									<td>
										<select v-model="dataset.resp.receipt.currency" class="form-control">
											<option value="EGP">{{ $t('EGP') }}</option>
											<option value="RSA">{{ $t('RSA') }}</option>
											<option value="USD">{{ $t('USD') }}</option>
										</select>
									</td>
								</tr>
								<tr>
									<th>{{ $t('payment method') }}</th>
									<td>
										<select v-model="dataset.resp.receipt.payment_method" class="form-control">
											<option value="cash">{{ $t('Cash') }}</option>
											<option value="visa">{{ $t('Visa') }}</option>
										</select>
									</td>
								</tr>
								<tr>
									<th>{{ $t('title coloumn') }}</th>
									<td>
										<select v-model="dataset.resp.receipt.elem_title_col" class="form-control">
											<option v-for="sc in dataset.ds_data.ds_schema" :value="sc.name">{{ sc.name }}</option>
										</select>
									</td>
								</tr>
								<tr>
									<th>{{ $t('price coloumn') }}</th>
									<td>
										<select v-model="dataset.resp.receipt.elem_price_col" class="form-control">
											<option v-for="sc in dataset.ds_data.ds_schema" :value="sc.name">{{ sc.name }}</option>
										</select>
									</td>
								</tr>
								<tr>
									<th>{{ $t('amount count coloumn') }}</th>
									<td>
										<select v-model="dataset.resp.receipt.elem_amount_col" class="form-control">
											<option v-for="sc in dataset.ds_data.ds_schema" :value="sc.name">{{ sc.name }}</option>
										</select>
									</td>
								</tr>
								<tr>
									<th>{{ $t('elem image col') }}</th>
									<td>
										<select v-model="dataset.resp.receipt.elem_image_col" class="form-control">
											<option v-for="sc in dataset.ds_data.ds_schema" :value="sc.name">{{ sc.name }}</option>
										</select>
									</td>
								</tr>
								<tr>
									<th>{{ $t('address') }}</th>
									<td>
										<input
											type="text"
											class="form-control"
											v-model="dataset.resp.receipt.address"
											:placeholder="$t('address')"
											v-autocomplete="autocomplete"
										/>
									</td>
								</tr>
								<tr>
									<th>{{ $t('shipping cost') }}</th>
									<td>
										<input
											type="text"
											class="form-control"
											v-model="dataset.resp.receipt.shipping_cost"
											:placeholder="$t('shipping cost')"
											v-autocomplete="autocomplete"
										/>
									</td>
								</tr>
								<tr>
									<th>{{ $t('total tax') }}</th>
									<td>
										<input
											type="text"
											class="form-control"
											v-model="dataset.resp.receipt.total_tax"
											:placeholder="$t('total tax')"
											v-autocomplete="autocomplete"
										/>
									</td>
								</tr>
							</table>
						</div>
					</div>
					<!-- END RESPONSE TYPE DATASET -->

					<!-- START RESPONSE TYPE DATA SOURCE -->
					<div v-if="record.resp_type == 'data_source'">
						<div class="h4">{{ $t('Database connection & query') }}</div>
						<tooltip label="Datasource connection" placement="right">
							<select
								name="resp_data_source_id"
								v-on:change="get_data_source_tables"
								v-model="record.resp_data_source_id"
								:disabled="!data_sources.length"
								v-validate="record.resp_type == 'data_source' ? 'required' : ''"
								:class="{'form-control': true, 'is-invalid': (!!data_source_error.length || errors.has('resp_data_source_id'))}"
							>
								<option value="0" disabled="disabled">{{ $t('choose datasource connection') }}</option>
								<option
									v-for="ds in data_sources"
									:value="ds.data_source_id"
									v-if="!ds.deleted_at"
								>{{ $t(ds.entity.driver) }}&#64;{{ ds.entity.name }}</option>
							</select>
							<span v-if="errors.has('resp_data_source_id')" class="help is-danger invalid-feedback">
								{{ $t(errors.first('resp_data_source_id')) }}
								<tooltip
									v-if="data_source_error.length"
									:label="data_source_error"
									:withSlot="false"
									noTranslate
									error
									placement="right"
								/>
							</span>
						</tooltip>
						<tooltip label="Type your sql query" placement="right">
							<codemirror
								ref="codemirror"
								:placeholder="$t('Type your sql query')"
								:options="cmOptions"
								v-model="record.resp_data_source_query_string"
							></codemirror>
						</tooltip>
						<div class="h4">{{ $t('Response Info') }}</div>
						<tooltip label="Data Limit" placement="right">
							<input
								name="text"
								v-model.lazy="record.resp_data_source_resp_data_limit"
								class="form-control"
								type="text"
							/>
						</tooltip>
						<tooltip label="Response Via" placement="right">
							<select class="form-control" v-model="record.resp_data_source_resp_via">
								<option value="text">{{ $t('Text') }}</option>
								<option value="card">{{ $t('Card URL or List') }}</option>
								<option value="quick_rep">{{ $t('Quick Replies') }}</option>
								<option value="video">{{ $t('Video') }}</option>
								<option value="Image">{{ $t('Image') }}</option>
							</select>
						</tooltip>
						<tooltip label="Text" placement="right" v-show="record.resp_data_source_resp_via == 'text'">
							<input
								class="form-control"
								v-autocomplete="autocomplete"
								v-model="record.resp_data_source_resp_struct.title_key"
								:placeholder="$t('Text')"
							/>
						</tooltip>
						<div v-if="record.resp_data_source_resp_via == 'quick_rep'">
							<CommandResponseQuickReply
								:autoCompleteModules="autocomplete"
								:records="record.resp_quick_reply"
								:private_services="private_services"
								:public_services="public_services"
								:command_id_to_name="command_id_to_name"
								v-on:passQuickReplies="onQuickReplySave"
							>
							</CommandResponseQuickReply>
						</div>
						<tooltip
							v-hide
							label="Default Text"
							placement="right"
							v-show="record.resp_data_source_resp_via == 'text'"
						>
							<input
								class="form-control"
								v-autocomplete="autocomplete"
								v-model="record.resp_data_source_resp_struct.title_default_value"
								:placeholder="$t('Default Text')"
							/>
						</tooltip>
						<ComamandResponseCard
							v-show="record.resp_data_source_resp_via === 'card'"
							:buttons="record.resp_data_source_resp_struct.buttons"
							:title="record.resp_data_source_resp_struct.title_key || record.resp_data_source_resp_struct.title_default_value"
							:subTitle="record.resp_data_source_resp_struct.subtitle_key || record.resp_data_source_resp_struct.subtitle_default_value"
							:autoCompleteModules="autocomplete"
							@onNewButtonClick="push_button(record.resp_data_source_resp_struct.buttons)"
							@onRemoveButtonClick="(pos) => remove_button(pos, record.resp_data_source_resp_struct.buttons)"
						>
							<template slot="title">
								<tooltip label="value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_data_source_resp_struct.title_key"
										:placeholder="$t('value')"
									/>
								</tooltip>
								<tooltip label="default value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_data_source_resp_struct.title_default_value"
										:placeholder="$t('default value')"
									/>
								</tooltip>
							</template>

							<template slot="subTitle">
								<tooltip label="value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_data_source_resp_struct.subtitle_key"
										:placeholder="$t('value')"
									/>
								</tooltip>
								<tooltip label="default value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_data_source_resp_struct.subtitle_default_value"
										:placeholder="$t('default value')"
									/>
								</tooltip>
							</template>

							<template slot="media">
								<tooltip label="value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_data_source_resp_struct.media_key"
										:placeholder="$t('value')"
									/>
								</tooltip>
								<tooltip label="default value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_data_source_resp_struct.media_default_value"
										:placeholder="$t('default value')"
									/>
								</tooltip>
							</template>

							<template
								:slot="'button.' + ii"
								v-for="(button, ii) in  record.resp_data_source_resp_struct.buttons"
							>
								<tooltip label="button label" placement="right" :key="'button.label.' + ii">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="button.item_label_key"
										:placeholder="$t('button label')"
									/>
								</tooltip>

								<tooltip label="button value" placement="right" :key="'button.value.' + ii">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="button.item_value_key"
										:placeholder="$t('button value')"
									/>
								</tooltip>
							</template>
						</ComamandResponseCard>
					</div>
					<!-- END RESPONSE TYPE DATA SOURCE -->

					<!-- START RESPONSE TYPE COMPONENT -->
					<div v-show="record.resp_type.toUpperCase() == 'COMPONENT'">
						<tooltip label="component" placement="right">
							<select name="component" v-model="record.resp_component_id" class="form-control">
								<optgroup v-for="component in Object.keys(components)" :label="component" :key="component">
									<option
										v-for="component in components[component]"
										:value="component.comp_id"
										:key="`component-${component.comp_id}`"
										:selected="record.resp_component_id === component.comp_id"
									>{{ component.comp_title }}</option>
								</optgroup>
							</select>
						</tooltip>
						<tooltip label="Data Type" placement="right">
							<select class="form-control" v-model="record.resp_component_resp_data_type">
								<option value="multi">{{ $t('Multiple') }}</option>
								<option value="single">{{ $t('Signle') }}</option>
							</select>
						</tooltip>
						<tooltip
							label="Data Limit"
							placement="right"
							v-show="record.resp_component_resp_data_type == 'multi'"
						>
							<input
								name="resp_component_resp_data_limit"
								v-model.lazy="record.resp_component_resp_data_limit"
								class="form-control"
								type="text"
							/>
						</tooltip>
						<tooltip label="Response Via" placement="right">
							<select class="form-control" v-model="record.resp_component_resp_via">
								<option value="text">{{ $t('Text') }}</option>
								<option value="card">{{ $t('Card URL or List') }}</option>
								<option value="video">{{ $t('Video') }}</option>
								<option value="Image">{{ $t('Image') }}</option>
							</select>
						</tooltip>
						<ComamandResponseCard
							v-show="record.resp_component_resp_via === 'card'"
							:buttons="record.resp_component_resp_struct.buttons"
							:btnLabel="record.resp_component_resp_struct.item_label_key || record.resp_component_resp_struct.item_label_default_value"
							:title="record.resp_component_resp_struct.title_key || record.resp_component_resp_struct.title_default_value"
							:subTitle="record.resp_component_resp_struct.subtitle_key || record.resp_component_resp_struct.subtitle_default_value"
							:autoCompleteModules="autocomplete"
							@onNewButtonClick="push_button(record.resp_component_resp_struct.buttons)"
							@onRemoveButtonClick="(pos) => remove_button(pos, record.resp_component_resp_struct.buttons)"
						>
							<template slot="title">
								<tooltip label="value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_component_resp_struct.title_key"
										:placeholder="$t('value')"
									/>
								</tooltip>
								<tooltip label="default value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_component_resp_struct.title_default_value"
										:placeholder="$t('default value')"
									/>
								</tooltip>
							</template>
							<template slot="subTitle">
								<tooltip label="value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_component_resp_struct.subtitle_key"
										:placeholder="$t('value')"
									/>
								</tooltip>
								<tooltip label="default value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_component_resp_struct.subtitle_default_value"
										:placeholder="$t('default value')"
									/>
								</tooltip>
							</template>
							<template slot="media">
								<tooltip label="value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_component_resp_struct.media_key"
										:placeholder="$t('value')"
									/>
								</tooltip>
								<tooltip label="default value" placement="right">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="record.resp_component_resp_struct.media_default_value"
										:placeholder="$t('default value')"
									/>
								</tooltip>
							</template>

							<template
								:slot="'button.' + ii"
								v-for="(button, ii) in  record.resp_component_resp_struct.buttons"
							>
								<tooltip label="button label" placement="right" :key="'button.label.' + ii">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="button.item_label_key"
										:placeholder="$t('button label')"
									/>
								</tooltip>

								<tooltip label="button value" placement="right" :key="'button.value.' + ii">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="button.item_value_key"
										:placeholder="$t('button value')"
									/>
								</tooltip>
							</template>
						</ComamandResponseCard>

						<tooltip label="text" placement="right" v-show="record.resp_component_resp_via === 'text'">
							<input
								class="form-control"
								v-autocomplete="autocomplete"
								v-model="record.resp_component_resp_struct.title_key"
							/>
						</tooltip>
					</div>
					<!-- END RESPONSE TYPE COMPONENT -->
				</b-card>
				<!-- END RESPONSE TYPE CARD -->
				<!-- START RESPONSE FALLBACk MESSAGE  -->
				<b-card>
					<div slot="header">{{ $t('Response Fallback message') }}</div>
					<tooltip label="Fallback Message" placement="right">
						<input
							name="text"
							v-model="record.resp_fallback_msg"
							class="form-control"
							:placeholder="$t('type fallback message')"
							type="text"
							v-autocomplete="autocomplete"
						/>
					</tooltip>
				</b-card>
				<!-- END RESPONSE FALLBACk MESSAGE  -->
				<!-- START EXTRA OPTIONS RESPONSE CARD -->
				<b-card>
					<div slot="header">{{ $t('Extra options response') }}</div>

					<tooltip label="option message" placement="right">
						<input
							type="text"
							:placeholder="$t('option message')"
							class="form-control"
							v-model.lazy="record.resp_api_extra_resp.message"
						/>
					</tooltip>

					<table class="table table-bordered table-striped table-sm">
						<thead>
							<tr>
								<th>{{ $t('Label') }}</th>
								<th>{{ $t('Value') }}</th>
								<th>{{ $t('action') }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(opt, index) in record.resp_api_extra_resp.options" :key="`extra-opts-${index}`">
								<td v-html="opt.label"></td>
								<td
									v-html="Object.values(fixed_commands).indexOf(opt.value) >= 0 ? $t(opt.value) : opt.value"
								></td>
								<td class="col d-inline-flex justify-content-center align-items-center">
									<span @click="edit_opt_mode(index)" :title="$t('edit')">
										<i class="fa fa-edit"></i>
									</span>
									&nbsp;
									<span @click="remove_opt(index)" :title="$t('delete')">
										<i class="fa fa-remove"></i>
									</span>
								</td>
							</tr>
							<tr v-if="!(record.resp_api_extra_resp.options || []).length">
								<td colspan="2">
									<div class="text-center">{{ $t('no data') }}</div>
								</td>
							</tr>
						</tbody>
					</table>
					<div>
						<tooltip label="Option Label" placement="right">
							<input
								type="text"
								:placeholder="$t('Option Label')"
								class="form-control"
								v-model="extra_opt.label"
								v-autocomplete="autocomplete"
							/>
						</tooltip>
						<tooltip label="option value" placement="right">
							<select
								name="resp_action_type"
								:class="{'form-control': true}"
								@change="(e) => extra_opt.value = e.target.value"
							>
								<option
									value
									:selected="!(Object.values(fixed_commands).indexOf(extra_opt.value) >= 0)"
								>{{ $t('custom text') }}</option>
								<option
									v-for="(command, index) in Object.values(fixed_commands)"
									:key="`fixed-command-${index}`"
									:value="command"
								>{{ $t(command) }}</option>
							</select>
						</tooltip>
						<tooltip
							label="option value text"
							placement="right"
							v-if="!(Object.values(fixed_commands).indexOf(extra_opt.value) >= 0)"
						>
							<input
								type="text"
								class="form-control"
								v-model="extra_opt.value"
								:placeholder="$t('option value text')"
								v-autocomplete="autocomplete"
							/>
						</tooltip>
						<div class>
							<button
								type="button"
								v-show="opt_mode == 'add'"
								@click="add_opt()"
								class="btn btn-primary btn-sm"
							>{{ $t('Add') }}</button>
							<button
								type="button"
								v-show="opt_mode == 'edit'"
								@click="edit_opt()"
								class="btn btn-primary btn-sm"
							>{{ $t('Edit') }}</button>
						</div>
					</div>
				</b-card>
				<!-- END EXTRA OPTIONS RESPONSE CARD -->
				<!-- START USER DATA CARD -->
				<b-card>
					<div slot="header">
						{{ $t('User Data') }}
						<label class="switch switch-sm switch-text switch-info float-right mb-0">
							<input type="checkbox" v-model.lazy="record.resp_user_data_status" class="switch-input" />
							<span class="switch-label" :data-on="$t('On')" :data-off="$t('Off')"></span>
							<span class="switch-handle"></span>
						</label>
					</div>
					<div v-if="record.resp_user_data_status">
						<div class="control" v-show="record.resp_user_data_pars && record.resp_user_data_pars.length">
							<b-card>
								<h4>{{ $t('User Data Processes') }}</h4>
								<div class="row">
									<div class="col-sm-12">
										<table class="table table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th>{{ $t('Name') }}</th>
													<th>{{ $t('Value') }}</th>
													<th>{{ $t('Default Value') }}</th>
													<th>{{ $t('Is Primary') }}</th>
													<th>{{ $t('Edit') }}</th>
													<th>{{ $t('Delete') }}</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(par, index) in record.resp_user_data_pars">
													<td>{{ par.name }}</td>
													<!-- <td> {{ par.var_id }} </td> -->
													<td>{{ par.var_name }}</td>
													<td>{{ par.var_default_value }}</td>
													<td>{{ par.is_primary ? $t('primary') : '' }}</td>
													<td @click="edit_par_mode('resp_user_data_pars', index)">
														<i class="fa fa-edit fa-lg"></i>
													</td>
													<td @click="remove_par('resp_user_data_pars', index)">
														<i class="fa fa-remove fa-lg"></i>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</b-card>
						</div>
						<div class="control">
							<div class="form-group row">
								<div class="col-sm-6">
									<tooltip label="Set Mode Type" placement="right">
										<select
											name="resp_user_data_mode_name"
											v-model="record.resp_user_data_mode_name"
											v-validate="record.resp_user_data_status ? 'required' : ''"
											:class="{
														'form-control': true,
														'is-invalid': errors.has('resp_user_data_mode_name'),
													}"
										>
											<option value disabled>{{ $t('Choose One') }}</option>
											<option value="insert">{{ $t('Insert') }}</option>
											<option value="update">{{ $t('Update') }}</option>
											<option value="delete">{{ $t('Delete') }}</option>
											<option value="finish">{{ $t('End') }}</option>
										</select>
										<span
											v-if="errors.has('resp_user_data_mode_name')"
											class="help is-danger invalid-feedback"
										>{{ $t(errors.first('resp_user_data_mode_name')) }}</span>
									</tooltip>
								</div>
								<div class="col-sm-6">
									<tooltip label="From Dataset" placement="right">
										<select
											:disabled="!datasets_list.length"
											@change="generate_ds_schema(record.resp_user_data_dataset_id)"
											v-model="record.resp_user_data_dataset_id"
											class="form-control"
										>
											<option value="0" disabled>{{ $t('Choose One') }}</option>
											<option v-for="ds in datasets_list" :value="ds.ds_id">{{ ds.ds_name }}</option>
										</select>
									</tooltip>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-sm-3">
									<tooltip label="Columns Name" placement="right">
										<select
											:disabled="!record.resp_user_data_dataset_id"
											class="form-control"
											v-model="api_par_resp_user_data_pars.name"
										>
											<option value disabled>{{ $t('Choose One') }}</option>
											<option v-for="(v, _i) in user_data_ds_schema" :value="v.name">{{ v.name }}</option>
										</select>
									</tooltip>
								</div>
								<div class="col-sm-3">
									<tooltip label="Variables List" placement="right">
										<select class="form-control" v-model="api_par_resp_user_data_pars.var_id">
											<option value="0" disabled>{{ $t('Choose One') }}</option>
											<option v-for="(v, _i) in vars" :value="v.var_id">{{ v.var_name }}</option>
											<option
												v-if="'ds_schema' in dataset.ds_data"
												v-for="sc in dataset.ds_data.ds_schema"
												:value="sc.name"
											>{{ sc.name }}</option>
											<option
												class="hl-opt"
												v-for="(sk, x) in Object.keys($store.state.sender_info)"
												:value="sk"
											>{{ $t($store.state.sender_info[sk]) }}</option>
										</select>
									</tooltip>
								</div>
								<div class="col-sm-3">
									<tooltip label="Default Value" placement="right">
										<input
											type="text"
											class="form-control"
											v-model="api_par_resp_user_data_pars.var_default_value"
											v-autocomplete="autocomplete"
										/>
									</tooltip>
								</div>
								<div class="col-sm-3">
									<tooltip label="Is Primary" placement="right">
										<br />
										<label class="switch switch-sm switch-text switch-info float-left mb-0">
											<input
												type="checkbox"
												v-model.lazy="api_par_resp_user_data_pars.is_primary"
												class="switch-input"
											/>
											<span class="switch-label" :data-on="$t('On')" :data-off="$t('Off')"></span>
											<span class="switch-handle"></span>
										</label>
									</tooltip>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-sm-4">
									<button
										type="button"
										v-show="par_mode_resp_user_data_pars == 'add'"
										@click="add_par('resp_user_data_pars')"
										class="btn btn-primary btn-sm"
									>{{ $t('Add') }}</button>
									<button
										type="button"
										v-show="par_mode_resp_user_data_pars == 'edit'"
										@click="edit_par('resp_user_data_pars')"
										class="btn btn-primary btn-sm"
									>{{ $t('Edit') }}</button>
								</div>
							</div>
						</div>
					</div>
				</b-card>
				<!-- END USER DATA CARD -->
				<!-- Start Response Actions Card  -->
				<response-action
					headTitle="response"
					fieldPrefix="resp_action"
					:dataSet="record"
					:actions="responseActions"
					:customerSupportDepartments="cs_departments"
					:apiParameterVariables="vars"
					@change="handleOnChangeRecord"
				></response-action>
				<!-- End Response Actions Card -->

				<!-- START SAVE ACTION -->
				<button-save @click="save"></button-save>
				<!-- END SAVE ACTION -->
			</div>
		</CommandHeaderV2>

		<b-modal
			size="lg"
			ref="groupQueryModal"
			:title="$t('Add new query group')"
			:no-close-on-backdrop="true"
			hide-footer
			@ok="handleOnmodalQueryGroupClick('ok')"
			@cancel="handleOnmodalQueryGroupClick('cancel')"
			@hide="handleOnmodalQueryGroupClick('hide')"
		>
			<div class="row">
				<div class="col-md-6">
					<tooltip label="Field" placement="right">
						<select class="form-control" v-model.lazy="datasetQueryGroupElement.field_name">
							<option value="0" disabled>{{ $t('None') }}</option>
							<option
								v-for="(sc, sc_i) in dataset.ds_data.ds_schema"
								:value="sc.name"
								:key="`sc${sc_i}`"
							>{{ sc.name }}</option>
							<option class="hl-opt" value="__status">{{ $t('__Status') }}</option>
							<option class="hl-opt" value="__sender_id">{{ $t('__Sender') }}</option>
						</select>
					</tooltip>
				</div>
				<div class="col-md-6">
					<tooltip label="Relation" placement="right">
						<select class="form-control" v-model.lazy="datasetQueryGroupElement.rel">
							<option
								v-for="(o, i) in $store.state.command.response.dataset.query.statements"
								:value="o.value"
								:key="`crdqs-${i}`"
							>{{o.label}}</option>
						</select>
					</tooltip>
				</div>
				<div class="col-md-6">
					<tooltip label="Variable" placement="right">
						<select class="form-control" v-model.lazy="datasetQueryGroupElement.var_id">
							<option value="0" disabled>{{ $t('None') }}</option>
							<option v-for="(v, _i) in vars" :value="v.var_id" :key="`v.var_id-${_i}`">{{ v.var_name }}</option>
							<option
								class="hl-opt"
								v-for="(sk, x) in Object.keys($store.state.sender_info)"
								:key="`$store.state.sender_info-${x}`"
								:value="sk"
							>{{ $t($store.state.sender_info[sk]) }}</option>
						</select>
					</tooltip>
				</div>
				<div class="col-md-6">
					<tooltip label="Default Value" placement="right">
						<input
							class="form-control"
							type="text"
							:placeholder="$t('Default Value')"
							v-model.lazy="datasetQueryGroupElement.value"
						/>
					</tooltip>
				</div>
				<div class="col-md-12">
					<button
						type="button"
						class="btn btn-sm btn-primary"
						@click="handleOnmodalQueryGroupClick('ok')"
					>{{ $t('Save') }}</button>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import axios from 'axios'
	import InputTag from 'vue-input-tag'
	import cSwitch from '../../../components/Switch'
	import CommandHeaderV2 from '../../../components/CommandHeaderV2'
	import ComamandResponseCard from '../../../components/ComamandResponseCard'
	import CommandResponseQuickReply from '../../../components/CommandResponseQuickReply'
	import GeoLocation from '../../../components/GeoLocation'
	import ImageUploader from '../../../components/ImageUploader'
	import ResponseAction from '../../../components/ResponseAction'
	import Utilities from '../../../directives/Autocomplete/Utilities'
	import buttonSave from '../../../components/ButtonSave'
	import {codemirror} from 'vue-codemirror'

	export default {
		name: 'Response',
		components: {
			InputTag,
			cSwitch,
			CommandHeaderV2,
			ComamandResponseCard,
			CommandResponseQuickReply,
			GeoLocation,
			ImageUploader,
			ResponseAction,
			buttonSave,
			codemirror,
		},
		data() {
			return {
				dropzoneOptions: {
					url: `server/api/upload-image/static-cards`,
					thumbnailWidth: 150,
				},

				components: [],

				cmOptions: {
					mode: 'text/x-mariadb',
					...this.$store.state.cm_base_options,
				},
				adsResponseOptions: {
					mode: 'text/javascript',
					...this.$store.state.cm_base_options,
				},

				private_services: [],
				public_services: [],
				command_id_to_name: {},

				fixed_commands: {},
				data_sources_tables: [],
				autocomplete: {},
				cs_departments: [],
				current_resp_action_api_parameter: {
					index: -1,
					name: '',
					var_id: '',
					var_default_value: '',
				},
				menu_dataset: [],
				react_menu_extra: {
					position: -1,
					mode: 'add',
					label: '',
					value: '',
				},

				record: {
					resp_type: 'static_cards',
					resp_quick_reply: [],
					resp_text: '',
					resp_fallback_msg: '',
					resp_menu_id: 0,
					resp_menu_extra_options: [],
					resp_cart_action: 'insert',
					resp_cart_title: 0,
					resp_cart_quantity: 0,
					resp_data_source_id: 0,
					resp_data_source_query_string: '',
					resp_api_url: '',
					resp_api_req_type: 'get',
					resp_sub_channel: 0,
					resp_api_headers: '',
					resp_api_pars: [],
					resp_user_data_pars: [],
					resp_user_data_mode_name: '',
					resp_api_resp_type: 'json',
					resp_api_resp_data_field: '',
					resp_api_resp_data_type: 'single',
					resp_api_resp_data_limit: 3,
					resp_api_resp_via: 'text',
					resp_api_resp_struct: {
						title_key: '',
						title_default_value: '',
						subtitle_key: '',
						subtitle_default_value: '',
						media_key: '',
						media_default_value: '',
						item_label_key: '',
						item_label_default_value: '',
						item_value_key: '',
						item_value_default_value: '',
						buttons: [
							{
								item_label_key: '',
								item_label_default_value: '',
								item_value_key: '',
								item_value_default_value: '',
							},
						],
					},
					resp_component_resp_data_type: 'single',
					resp_component_resp_data_limit: 3,
					resp_component_resp_via: 'text',
					resp_component_resp_struct: {
						title_key: '',
						title_default_value: '',
						subtitle_key: '',
						subtitle_default_value: '',
						media_key: '',
						media_default_value: '',
						item_label_key: '',
						item_label_default_value: '',
						item_value_key: '',
						item_value_default_value: '',
						buttons: [
							{
								item_label_key: '',
								item_label_default_value: '',
								item_value_key: '',
								item_value_default_value: '',
							},
						],
					},
					resp_static_cards_resp_struct: [],
					resp_location_resp_struct: [],
					resp_api_extra_resp: {
						message: '',
						options: [],
					},
					resp_action_status: false,
					resp_actions: [],
					resp_user_data_dataset_id: 0,
					resp_data_source_resp_data_limit: 3,
					resp_data_source_resp_via: 'text',
					resp_data_source_resp_struct: {
						title_key: '',
						title_default_value: '',
						subtitle_key: '',
						subtitle_default_value: '',
						media_key: '',
						media_default_value: '',
						item_label_key: '',
						item_label_default_value: '',
						item_value_key: '',
						item_value_default_value: '',
						buttons: [
							{
								item_label_key: '',
								item_label_default_value: '',
								item_value_key: '',
								item_value_default_value: '',
							},
						],
					},
					resp_component_id: 0,
				},

				subs: [],
				vars: [],
				vars_ids: {},
				vars_ids_with_sender_vars: {},
				service_id: 0,
				command_id: 0,
				api_par_resp_api_pars: {
					var_name: '',
					var_id: 0,
					name: '',
					var_default_value: '',
				},
				api_par_resp_action_api_pars: {
					var_name: '',
					var_id: 0,
					name: '',
					var_default_value: '',
				},
				api_par_resp_user_data_pars: {
					is_primary: false,
					var_id: 0,
					var_name: '',
					name: '',
					var_default_value: '',
				},
				active_par_index_resp_api_pars: -1,
				active_par_index_resp_action_api_pars: -1,
				active_par_index_resp_user_data_pars: -1,
				par_mode_resp_api_pars: 'add',
				par_mode_resp_action_api_pars: 'add',
				par_mode_resp_user_data_pars: 'add',
				extra_opt: {
					label: '',
					value: '',
				},
				dataset: {
					ds_id: 0,
					ds_data: {},
					query_type: 'builder',
					groups: [[]],
					query_syntax: [],
					resp: {
						limit: 1,
						via: 'text',
						title: '',
						subtitle: '',
						media: '',
						item_label: '',
						item_value: '',
						buttons: [
							{
								item_label_key: '',
								item_value_key: '',
							},
						],
						receipt: {
							name: '',
							merchant: '',
							order_number: 0,
							timestamp: 0,
							order_url: 0,
							currency: 'EGP',
							payment_method: '',
							dataset_id: 0,
							elem_title_col: '',
							elem_price_col: 0,
							elem_amount_col: 1,
							elem_image_col: '',
							address: '',
							sub_total: 0,
							shipping_cost: 0,
							total_tax: 0,
							total_cost: 0,
						},
					},
				},
				datasetQueryGroupElement: {
					field_name: '0',
					rel: '=',
					var_id: '0',
					value: '',
					index: -1,
				},
				datasets_list: [],
				datasets_schema: {},
				opt_mode: 'add',
				active_opt_index: -1,
				deleteModal: false,
				active_element_id: 0,
				active_element_name: '',
				user_data_ds_schema: [],
				data_sources: [],
				data_source_error: '',
				mode_resp_static_cards_resp_struct: 'add',
				error_resp_static_cards_resp_struct: false,
				resp_static_cards_resp_struct: {
					title_key: '',
					title_default_value: '',
					subtitle_key: '',
					subtitle_default_value: '',
					media_key: '',
					media_default_value: '',
					buttons: [
						{
							item_label_key: '',
							item_label_default_value: '',
							item_value_key: '',
							item_value_default_value: '',
						},
					],
				},
				resp_location_resp_struct: {
					mode: 'add',
					error: false,
					title: '',
					lng: 0,
					lat: 0,
				},
				responseActions: this.$store.state.command.response.actions,
				react_text: {
					text: '',
					lines: [],
					line_pos: -1,
					text_line: '',
					mode: 'add',
				},
			}
		},

		methods: {
			get_services_commands(){
				axios.get('/service/get_list').then(({data}) => {
					if (data.status) {
						this.private_services = data.private;
						this.public_services = data.public;
						// assign command_id => name
						for(var i in this.private_services){
							for(var k in this.private_services[i].commands){
								this.command_id_to_name[ this.private_services[i].commands[k]['command_id'] ] = this.private_services[i].commands[k]['command_name'];
							}
						}

						for(var i in this.public_services){
							for(var k in this.public_services[i].commands){
								this.command_id_to_name[ this.public_services[i].commands[k]['command_id'] ] = this.public_services[i].commands[k]['command_name'];
							}
						}
					}
				})
			},
			handleOnChangeRecord(data) {
				var record = Utilities.deepExtend(this.record, data, true)
				this.record = {...record}
			},

			handle_on_change_res_type(e) {
				if (e.target.value != 'shopping_cart') {
					this.record.resp_cart_action = 'insert'
				}
				switch (e.target.value) {
					case 'ds':
						this.get_dataset_fields()
						break
					default:
						this.setAutoCompeleteSchema()
				}
			},

			add_par(key) {
				var par_name = 'api_par_' + key
				if (
					this[par_name].name != '' &&
					(this[par_name].var_id != '' || this[par_name].var_default_value != '') &&
					!this.check_exist_par(key, this[par_name].name)
				) {
					// set var name where var_id belongs to sender info object
					if (this.$store.state.sender_info.hasOwnProperty(this[par_name].var_id)) {
						this[par_name].var_name = this.$store.state.sender_info[this[par_name].var_id]
					} else {
						// set default var
						for (var _i in this.vars) {
							if (this.vars[_i].var_id == this[par_name].var_id) {
								this[par_name].var_name = this.vars[_i].var_name
								break
							}
						}
					}

					// find col type
					for (var _d in this.user_data_ds_schema) {
						if (this.user_data_ds_schema[_d]['name'] == this[par_name]['name']) {
							this[par_name]['type'] = this.user_data_ds_schema[_d]['type']
						}
					}

					this.record[key].push(this[par_name])

					this[par_name] = {
						var_name: '',
						var_id: 0,
						name: '',
						var_default_value: '',
					}
				}
			},

			edit_par(key) {
				var par_name = 'api_par_' + key

				if (this['active_par_index_' + key] >= 0 && this[par_name].name != '') {
					if (this.$store.state.sender_info.hasOwnProperty(this[par_name].var_id)) {
						this[par_name].var_name = this.$store.state.sender_info[this[par_name].var_id]
					} else {
						for (var _i in this.vars) {
							if (this.vars[_i].var_id == this[par_name].var_id) {
								this[par_name].var_name = this.vars[_i].var_name
								break
							}
						}
					}

					for (var i = 0; i < this.record[key].length; i++) {
						if (i == this['active_par_index_' + key]) {
							this.record[key][i] = this[par_name]
						}
					}
					this['active_par_index_' + key] = -1
					this['par_mode_' + key] = 'add'
					this[par_name] = {
						var_name: '',
						var_id: 0,
						name: '',
						var_default_value: '',
					}
				}
			},

			edit_par_mode(key, index) {
				this['par_mode_' + key] = 'edit'
				this['active_par_index_' + key] = index
				this['api_par_' + key] = this.record[key][index]
			},

			check_exist_par(key, name) {
				for (var i = 0; i < this.record[key].length; i++) {
					if (this.record[key][i].name == name) {
						return true
					}
				}
				return false
			},

			remove_par(key, index) {
				if (this.record[key] && this.record[key][index]) {
					this.record[key].splice(index, 1)
				}
			},

			add_opt() {
				if (
					this.extra_opt.label != '' &&
					this.extra_opt.value != '' &&
					!this.check_exist_opt(this.extra_opt.label)
				) {
					this.record.resp_api_extra_resp.options.push(this.extra_opt)
					this.extra_opt = {
						label: '',
						value: '',
					}
				}
			},
			edit_opt_mode(index) {
				this.opt_mode = 'edit'
				this.active_opt_index = index
				this.extra_opt = this.record.resp_api_extra_resp.options[index]
				return true
			},
			check_exist_opt(label) {
				for (var i = 0; i < this.record.resp_api_extra_resp.options.length; i++) {
					if (this.record.resp_api_extra_resp.options[i].label == label) {
						return true
					}
				}
				return false
			},
			edit_opt() {
				if (this.active_opt_index >= 0 && this.extra_opt.label != '' && this.extra_opt.value != '') {
					for (var i = 0; i < this.record.resp_api_extra_resp.options.length; i++) {
						if (i == this.active_opt_index) {
							this.record.resp_api_extra_resp.options[i] = this.extra_opt
						}
					}
					this.active_opt_index = -1
					this.opt_mode = 'add'
					this.extra_opt = {
						label: '',
						value: '',
					}
				}
			},
			remove_opt(index) {
				var recs = []
				for (var i = 0; i < this.record.resp_api_extra_resp.options.length; i++) {
					if (i != index) {
						recs.push(this.record.resp_api_extra_resp.options[i])
					}
				}
				this.record.resp_api_extra_resp.options = recs
			},

			get_dataset_fields() {
				this.dataset.ds_data = {}
				this.setAutoCompeleteSchema()
				if ('ds' == this.record.resp_type && this.dataset.ds_id) {
					axios.get('/dataset/browse/' + this.dataset.ds_id, {}).then((response) => {
						if (response.data.status) {
							this.dataset.ds_data = response.data.data
						}
						this.setAutoCompeleteSchema()
					})
				}
			},

			get_data_source_tables() {
				return new Promise((resolve, reject) => {
					if ('data_source' == this.record.resp_type && this.record.resp_data_source_id) {
						this.data_source_error = ''
						this.data_sources_tables = []
						this.errors.remove('resp_data_source_id')
						axios
							.post(
								'/data_sources/get_tables_name',
								{
									data_source_id: this.record.resp_data_source_id,
								},
								{}
							)
							.then(({data}) => {
								if (data.status === 1) {
									this.data_sources_tables = data.data
								} else {
									this.data_source_error = data.msg
									this.errors.add({
										field: 'resp_data_source_id',
										msg: 'Failed connection',
									})
								}
								// this.setAutoCompeleteSchema()
								resolve(data)
							})
					} else {
						resolve()
					}
				})
			},

			setAutoCompeleteSchema() {
				this.autocomplete = {
					...this.autocomplete,
					'@v': {
						icon: 'fa-at',
						short_descroption: this.$t('variables'),
						list: Object.values(this.vars_ids_with_sender_vars).concat(
							(() => {
								if (this.record.resp_type != 'ds') return []

								if (this.dataSetHasNearByStatements(this.dataset.groups.slice())) {
									return this.$store.state.command.response.dataset.query.autoCompleteExtraVariables
								}

								return []
							})()
						),
					},
					'@d': {
						icon: 'fa-database',
						short_descroption: (() => {
							switch (this.record.resp_type) {
								case 'ds':
									return 'Dataset ' + (this.dataset.ds_data.ds_name || '')
								default:
									return 'Database'
							}
						})(),
						list: (() => {
							switch (this.record.resp_type) {
								case 'ds':
									return (
										this.dataset.ds_data.ds_schema ||
										[
											/* empty array required */
										]
									).reduce((a, b) => {
										return a.concat(b.name)
									}, [])
								default:
									return []
							}
						})(),
					},
				}
			},

			addNewQueryGroup() {
				this.dataset.groups.push([])
			},

			removeQueryGroup(group_index) {
				this.dataset.groups.splice(group_index, 1)
				this.checkAutoCompleteHasVariableNearby()
			},
			addQueryElement(group_index) {
				if (
					this.datasetQueryGroupElement.field_name != '0' &&
					this.datasetQueryGroupElement.var_id != '0' &&
					this.dataset.groups[group_index]
				) {
					// get field type
					if (this.datasets_schema[this.dataset.ds_id][this.datasetQueryGroupElement.field_name] != undefined) {
						this.datasetQueryGroupElement.field_type = this.datasets_schema[this.dataset.ds_id][
							this.datasetQueryGroupElement.field_name
						]
					}
					// append field to the group
					this.dataset.groups[group_index].push(this.datasetQueryGroupElement)
					// reset form element
					this.datasetQueryGroupElement = {
						field_name: '0',
						var_id: '0',
						rel: '=',
						value: '',
						index: -1,
					}
					this.checkAutoCompleteHasVariableNearby()
				}
			},

			removeQueryGroupElement(group_index, element_index) {
				this.dataset.groups[group_index] && this.dataset.groups[group_index].splice(element_index, 1)
				this.checkAutoCompleteHasVariableNearby()
			},

			save() {
				var record = clone(this.record)
				record.resp_dataset = this.dataset

				if (this.data_source_error.length) return false

				var scopeFields = (() => {
					switch (record.resp_type) {
						case 'text':
							return []
						case 'menu':
							return ['menu_dataset']
						case 'shopping_cart':
							return ['menu_dataset', 'resp_cart_action', 'resp_cart_title']
					}
					return []
				})()

				this.$validator.validateAll(scopeFields).then((success) => {
					if (success) {
						this.$root.loader = true
						axios
							.post('/command_response/save/' + this.command_id, {
								record: record,
							})
							.then((response) => {
								this.$root.loader = false
								if (response.data.status == 1) {
									this.$root.notify({
										message: this.$t('successfully updated'),
										status: 'success',
										area: 'topRight',
									})
								}
							})
							.catch((e) => {
								this.$root.loader = false
								this.$root.notify({
									message: this.$t('server error'),
									status: 'error',
									autoHide: true,
									area: 'topRight',
								})
							})
					}
				})
			},

			get_fixed_commands() {
				return new Promise((resolve, reject) => {
					axios
						.get('/command/get_fixed_commands')
						.then((res) => {
							if (res.data.status == 1 && is_obj(res.data.data)) {
								this.fixed_commands = res.data.data
							}
							resolve(res)
						})
						.catch((e) => {
							resolve(e)
						})
				})
			},

			async get_command_response() {
				const res = await axios.get('/command_response/get/' + this.command_id)

				if (res.data.status != 1) return

				var record = res.data.data

				if (!is_obj(record.resp_data_source_resp_struct)) {
					record.resp_data_source_resp_struct = {
						title_key: '',
						title_default_value: '',
						subtitle_key: '',
						subtitle_default_value: '',
						media_key: '',
						media_default_value: '',
						item_label_key: '',
						item_label_default_value: '',
						item_value_key: '',
						item_value_default_value: '',
						buttons: [
							{
								item_label_key: '',
								item_label_default_value: '',
								item_value_key: '',
								item_value_default_value: '',
							},
						],
					}
				}
				if (!is_arr(record.resp_static_cards_resp_struct)) {
					record.resp_static_cards_resp_struct = []
				}

				if (!is_arr(record.resp_location_resp_struct)) {
					record.resp_location_resp_struct = []
				}

				if (!record.resp_dataset) {
					record.resp_dataset = this.dataset
				}

				if (!is_arr(record.resp_data_source_resp_struct.buttons)) {
					record.resp_data_source_resp_struct.buttons = [
						{
							item_label_key: record.resp_data_source_resp_struct.item_label_key || '',
							item_label_default_value: record.resp_data_source_resp_struct.item_label_default_value || '',
							item_value_key: record.resp_data_source_resp_struct.item_value_key || '',
							item_value_default_value: record.resp_data_source_resp_struct.item_value_default_value || '',
						},
					]
				}

				if (!is_arr(record.resp_api_resp_struct.buttons)) {
					record.resp_api_resp_struct.buttons = [
						{
							item_label_key: record.resp_api_resp_struct.item_label_key || '',
							item_label_default_value: record.resp_api_resp_struct.item_label_default_value || '',
							item_value_key: record.resp_api_resp_struct.item_value_key || '',
							item_value_default_value: record.resp_api_resp_struct.item_value_default_value || '',
						},
					]
				}

				// ! REMOVED JUST TO MAKE IT WORK!!
				// if (!is_arr(record.resp_dataset.resp.buttons)) {
				// 	record.resp_dataset.resp.buttons = [
				// 		{
				// 			item_label_key: record.resp_dataset.resp.item_label || '',
				// 			item_value_key: record.resp_dataset.resp.item_value || '',
				// 		},
				// 	]
				// }

				if (record.resp_user_data_dataset_id) {
					this.generate_ds_schema(res.data.data.resp_user_data_dataset_id)
				}

				if (record.resp_api_resp_struct.receipt && record.resp_api_resp_struct.receipt.dataset_id) {
					this.generate_ds_schema(record.resp_api_resp_struct.receipt.dataset_id)
				} else if (record.resp_user_data_dataset_id) {
					this.generate_ds_schema(record.resp_user_data_dataset_id)
				}

				if (!is_obj(record.resp_api_extra_resp)) {
					var resp_opts_clone = clone(record.resp_api_extra_resp || [])
					record.resp_api_extra_resp = {
						message: '',
						options: resp_opts_clone,
					}
				}

				if (!is_arr(record.resp_menu_extra_options)) {
					record.resp_menu_extra_options = []
				}

				if (!is_arr(record.resp_quick_reply)) {
					record.resp_quick_reply = []
				}

				this.dataset = record.resp_dataset

				record = Utilities.deepExtend(record, this.record, true)

				this.record = {
					...record,
				}

				this.setAutoCompeleteSchema()
			},

			get_command_vars() {
				return new Promise((resolve, reject) => {
					axios
						.post('/command_var/get_all/' + this.command_id, {}, {})
						.then((res) => {
							if (res.data.status == 1) {
								this.vars = res.data.data
								// map id to names
								for (var _var in res.data.data) {
									this.vars_ids[res.data.data[_var].var_id] = res.data.data[_var].var_name
								}
								// Set Sender Info options
								this.vars_ids_with_sender_vars = {
									...this.vars_ids,
									...this.$store.state.sender_info,
								}
								this.setAutoCompeleteSchema()
							}
							resolve('success')
						})
						.catch((e) => resolve('error'))
				})
			},

			get_datasets() {
				return new Promise((resolve, reject) => {
					axios
						.get('/dataset/get_list?type=dataset,menu', {})
						.then((res) => {
							if (res.data.status == 1) {
								this.datasets_list = res.data.private
								for (var _i in res.data.private) {
									this.datasets_schema[res.data.private[_i].ds_id] = {}
									for (var _s in res.data.private[_i].ds_schema) {
										this.datasets_schema[res.data.private[_i].ds_id][
											res.data.private[_i].ds_schema[_s]['name']
										] = res.data.private[_i].ds_schema[_s]['type']
									}
								}
							}
							resolve(res)
						})
						.catch((e) => reject(e))
				})
			},

			get_datasources() {
				return new Promise((resolve, reject) => {
					axios
						.get(`/data_sources?all`)
						.then(({data}) => {
							if (data.status) {
								this.data_sources = data.data
							}
							resolve(data)
						})
						.catch((e) => reject(e))
				})
			},

			generate_ds_schema(ds_id) {
				this.user_data_ds_schema = []
				for (var i = this.datasets_list.length - 1; i >= 0; i--) {
					if (ds_id == this.datasets_list[i].ds_id) {
						this.user_data_ds_schema = this.datasets_list[i].ds_schema
						break
					}
				}
			},

			push_button(btns_arr) {
				btns_arr.push({
					item_label_key: '',
					item_label_default_value: '',
					item_value_key: '',
					item_value_default_value: '',
				})
			},
			remove_button(pos, btns_arr) {
				btns_arr.splice(pos, 1)
			},

			static_card_emit(mode, pos) {
				var card = this.resp_static_cards_resp_struct
				var cards = this.record.resp_static_cards_resp_struct || []
				var empty_card = {
					title_key: '',
					title_default_value: '',
					subtitle_key: '',
					subtitle_default_value: '',
					media_key: '',
					media_default_value: '',
					buttons: [
						{
							item_label_key: '',
							item_label_default_value: '',
							item_value_key: '',
							item_value_default_value: '',
						},
					],
				}
				// check if a valid card
				if (
					mode !== 'edit' &&
					mode !== 'delete' &&
					((!card.media_key.length && !card.media_default_value.length) ||
						(!card.title_key.length && !card.title_default_value.length))
				) {
					this.error_resp_static_cards_resp_struct = 'please complete required fields like media & title!'
					return false
				} else {
					this.error_resp_static_cards_resp_struct = false
				}

				switch (mode) {
					case 'add':
						if (cards.length < 5) {
							cards.push(card)
							this.resp_static_cards_resp_struct = {
								...empty_card,
							}
						}
						break
					case 'edit':
						this.resp_static_cards_resp_struct = {
							pos: pos,
							...cards[pos],
						}
						this.mode_resp_static_cards_resp_struct = 'edit'
						break
					case 'update':
						if (is_num(card.pos)) {
							pos = card.pos
							delete card['pos']
							cards[pos] = {...card}
							this.resp_static_cards_resp_struct = {
								...empty_card,
							}
							this.mode_resp_static_cards_resp_struct = 'add'
						}
						break
					case 'delete':
						if (is_num(pos)) {
							cards.splice(pos, 1)
						}
						break
				}
			},
			location_emit(mode, pos) {
				var location = this.resp_location_resp_struct
				var locations = this.record.resp_location_resp_struct || []
				var empty_location = {
					mode: 'add',
					error: false,
					title: '',
					lng: 0,
					lat: 0,
				}
				// check if a valid location
				if (mode !== 'edit' && mode !== 'delete' && (!is_num(location.lng) || !is_num(location.lat))) {
					this.resp_location_resp_struct.error = 'please complete required fields!'
					return false
				} else {
					this.resp_location_resp_struct.error = false
				}

				switch (mode) {
					case 'add':
						if (locations.length < 5) {
							locations.push({
								title: location.title,
								lng: location.lng,
								lat: location.lat,
							})
							this.resp_location_resp_struct = {...empty_location}
						}
						break
					case 'edit':
						this.resp_location_resp_struct = {
							mode: 'edit',
							pos: pos,
							...locations[pos],
						}
						break
					case 'update':
						if (is_num(location.pos)) {
							pos = location.pos
							locations[pos] = {
								title: location.title,
								lng: location.lng,
								lat: location.lat,
							}

							this.resp_location_resp_struct = {...empty_location}
						}
						break
					case 'delete':
						if (is_num(pos)) {
							locations.splice(pos, 1)
						}
						break
				}
			},
			handleOnChangeMarker(latLng) {
				this.resp_location_resp_struct = {
					...this.resp_location_resp_struct,
					lat: latLng.lat,
					lng: latLng.lng,
				}
			},

			autoCompleteTextToHTML(str, modules = this.autocomplete) {
				if (Object.keys(modules).length) return autoCompleteTextToHTML(str, modules)
				return str
			},

			set_customer_support_status() {
				return new Promise((resolve, reject) => {
					if (
						this.$store.state.user &&
						this.$store.state.user.hasOwnProperty('user_customer_support') &&
						this.$store.state.user.user_customer_support &&
						this.$store.state.user.user_customer_support.cs_status
					) {
						this.responseActions = this.responseActions.concat(
							[
								{
									label: 'connect to customer support',
									value: 'cs_connect',
								},
							],
							[
								{
									label: 'disconnect from customer support',
									value: 'cs_disconnect',
								},
							]
						)
						// get departments for cs.
						axios
							.get('/user/get_cs_departments')
							.then((res) => {
								if (res.data.status) {
									this.cs_departments = res.data.data
									var c_cs_departments = clone(this.cs_departments),
										cs
									while ((cs = c_cs_departments.pop())) {
										if (cs.id == this.resp_action_cs_connect_department) {
											c_cs_departments.push(cs)
											break
										}
									}
									if (!c_cs_departments.length) {
										this.resp_action_cs_connect_department = null
									}
									resolve('success')
								}
							})
							.catch((e) => {
								resolve('success')
							})
					} else {
						delete this.fixed_commands.cs_connect
						delete this.fixed_commands.cs_disconnect
						this.fixed_commands = {
							...this.fixed_commands,
						}
						resolve('success')
					}
					resolve('success')
				})
			},

			get_menu_dataset() {
				return new Promise((resolve, reject) => {
					axios
						.get('/dataset/get_list?type=menu')
						.then((res) => {
							if (res.data.status === 1) {
								this.menu_dataset = res.data.private
							}
							resolve('success')
						})
						.catch((e) => {
							resolve('error')
						})
				})
			},

			async get_components() {
				const {data} = await axios.get('components')
				this.components = data.components
			},

			handle_click_menu_extra() {
				this.$validator.validateAll(['resp_menu_extra_opt_label', 'resp_menu_extra_opt_value']).then((success) => {
					if (success) {
						const {mode, label, value, position} = this.react_menu_extra
						if ('add' == mode) {
							this.record.resp_menu_extra_options.push({
								label,
								value,
							})
						} else {
							if (this.record.resp_menu_extra_options[position]) {
								this.record.resp_menu_extra_options[position] = {
									label,
									value,
								}
							}
						}
						this.react_menu_extra = {
							position: -1,
							mode: 'add',
							label: '',
							value: '',
						}
					}
				})
			},

			handleOnClickAddQuery(index) {
				this.$refs.groupQueryModal && this.$refs.groupQueryModal.show()
				this.datasetQueryGroupElement.index = index
			},

			handleOnmodalQueryGroupClick(mode) {
				switch (mode) {
					case 'ok':
						if (
							this.datasetQueryGroupElement.index >= 0 &&
							this.datasetQueryGroupElement.field_name != '0' &&
							this.datasetQueryGroupElement.var_id != '0'
						) {
							this.addQueryElement(this.datasetQueryGroupElement.index)
							this.$refs.groupQueryModal && this.$refs.groupQueryModal.hide()
						}

						break

					default:
						break
				}
			},

			checkAutoCompleteHasVariableNearby() {
				this.setAutoCompeleteSchema()
			},

			dataSetHasNearByStatements(queryGroups) {
				const quieresRelation = queryGroups.reduce((prev, current) => {
					return prev.concat(
						current.reduce((cprev, ccurrent) => {
							return cprev.concat(ccurrent.rel)
						}, [])
					)
				}, [])

				return 0 <= quieresRelation.indexOf('nearby')
			},
			onQuickReplySave(data){
				if(Array.isArray(data)){
					this.record['resp_quick_reply'] = data;
				} else {
					this.record['resp_quick_reply'] = [];
				}
				return true;
			}

			// @methods
		},

		async created() {
			this.$root.loader = true

			this.autocomplete = Object.assign(this.autocomplete, clone(this.$store.state.autocomplete))

			if (parseInt(this.$route.params.service_id) >= 1) {
				this.service_id = parseInt(this.$route.params.service_id)
			}

			if (parseInt(this.$route.params.command_id) >= 1) {
				this.command_id = parseInt(this.$route.params.command_id)
			}

			await this.get_fixed_commands()

			await this.get_command_response()

			await this.get_services_commands()

			await this.get_command_vars()

			await this.get_datasets()

			await this.get_datasources()

			await this.get_data_source_tables()

			await this.set_customer_support_status()

			await this.get_menu_dataset()

			await this.get_components()

			this.$root.loader = false
		},
	}
</script>
